import { IAppState } from '../../redux';
import { IServicePeriod } from '../../redux/reducers';

export function selectActivePeriod(state: IAppState): IServicePeriod | null {
  const { publishTerms } = state;
  const { periodsByService, selectedPeriodId, selectedServiceId } = publishTerms;
  const periodsInfo = !!selectedServiceId && periodsByService[selectedServiceId];

  if (!selectedPeriodId || !periodsInfo) {
    return null;
  }

  return periodsInfo.periods[selectedPeriodId] || null;
}
